import { CalculationType } from '@ptg-member/features/calculation/types/enums';
import { pensionDropPlanIcon, pensionEstimatorIcon, priceChange } from '@ptg-shared/constance/listIcons.const';
import { PERMISSION_KEY, SUBMODULE_KEY } from '@ptg-shared/constance/permission.const';
import { DisplayedTabName, MUNICIPALITY_PARTICIPANTS_MENU_TITLE, ItemMenuType } from '@ptg-shared/layout/constance/layout.const';
import { Menu, MenuGroup } from '@ptg-shared/layout/models/layout.model';
import { FundType } from '@ptg-shared/types/enums';

export const BULK_UPDATE_MENU_LIST: Menu[] = [
  {
    title: 'Bulk Content Update',
    menuItems: [
      // added dynamically within the SidebarComponent
      {
        name: 'Mixed Bulk Update',
        routerLink: '/member/bulk/mixed',
        className: '',
      },
    ],
  },
];

export const FUND_MENU_LIST: Menu[] = [
  {
    title: 'PAS Management',
    menuItems: [{ name: 'Theme', routerLink: '/fund-management/theme' }],
  },
  {
    title: 'Integrations',
    menuItems: [{ name: 'Stripe', routerLink: '/fund-management/stripe' }],
  },
];

export const OST_MENU_LIST: Menu[] = [
  {
    title: 'OST Integrations',
    menuItems: [
      { name: 'Office of State Treasurer', routerLink: '/admin/ost-integrations/office-of-state-treasurer' },
      { name: 'Lead Time & Waiting Time', routerLink: '/admin/ost-integrations/lead-time-and-waiting-time' },
      { name: 'OST Input File Register', routerLink: '/admin/ost-integrations/ost-input-file-register' },
    ],
  },
]

export const CONTENT_MENU_LIST: Menu[] = [
  {
    title: 'App Content Management',
    menuItems: [
      { name: 'Navigation', routerLink: '/fund-management/navigation' },
      { name: 'Preferences', routerLink: '/fund-management/preferences' },
      { name: 'Mixed Bulk Add', routerLink: '/page/mixed-bulk-add' },
    ],
  },
  {
    title: 'Content',
    menuItems: [
      // added dynamically within the SidebarComponent
    ],
  },
];

export const MEMBER_OVERVIEW_MENU_LIST: Menu[] = [
  {
    title: '',
    menuItems: [{ name: 'Overview', routerLink: '/member/detail/' }],
  },
];

export const EXTERNAL_PAYMENT_MENU_LIST: Menu[] = [
  {
    title: 'External Payment',
    menuItems: [
      {
        name: 'Disbursement Reports',
        routerLink: '/admin/disbursement-report',
        routerLinkExpand: ['/admin/disbursement-report/'],
      },
      {
        name: 'Vendor',
        routerLink: '/admin/vendor',
      },
    ],
  },
];

export const RESOURCE_CENTER_MENU_LIST: Menu[] = [
  {
    title: 'Resource Center',
    menuItems: [
      {
        name: 'File Upload/Transfer',
        routerLink: '/fund-management/resource-center',
      },
    ],
  },
  {
    title: 'Configuration',
    menuItems: [
      {
        name: 'Notifications',
        routerLink: '/fund-management/resource-center/notification',
      },
      {
        name: 'Categories',
        routerLink: '/fund-management/resource-center/manage-category',
      },
    ],
  },
];

export const NOTIFICATION_MENU_LIST: Menu[] = [
  {
    title: 'Communications',
    menuItems: [{ name: 'SMS Messaging', routerLink: '/fund-management/notification' }],
  },
  {
    title: 'Setting',
    icon: 'tune',
    style: 'padding-top: 16px; border-top: 1px solid #124462; margin-right: 15px;',
    menuItems: [
      {
        name: 'Opt-In Messaging',
        routerLink: '/fund-management/notification/opt-in-message',
      },
    ],
  },
];

export const MEMBER_DOCUMENT_LIST: Menu[] = [
  {
    title: 'Documents',
    menuItems: [
      {
        name: 'Document List',
        routerLink: '/member/document-list',
        routerLinkExpand: ['/document-list'],
      },
    ],
  },
  {
    title: 'Letter',
    menuItems: [
      {
        name: 'Age 65 Letter',
        routerLink: '/member/generate-age65-letter',
        routerLinkExpand: ['/member/generate-age65-letter'],
      },
    ],
    fundType: FundType.BVFF,
  },
  {
    title: 'Reports',
    menuItems: [
      {
        name: 'Actuary Report',
        routerLink: '/member/actuary-report',
        routerLinkExpand: ['/member/actuary-report'],
        fundType: FundType.BVFF,
      },
      {
        name: 'Ad Hoc Report',
        routerLink: '/member/adhoc-report',
        fundType: [FundType.BVFF, FundType.ChicagoParks],
      }
    ],
  }
];

export const PENSION_ESTIMATOR_LIST: Menu[] = [
  {
    title: 'Pension Estimator',
    menuItems: [
      {
        name: 'Pension Estimator',
        routerLink: '/estimator',
        routerLinkExpand: ['/estimator/estimator-config'],
      },
    ],
  },
];

export const PENSION_DROP_PLAN_LIST: Menu[] = [
  {
    title: 'DROP Plan',
    menuItems: [
      {
        name: 'DROP Plan',
        routerLink: '/member/drop-plan',
        routerLinkExpand: ['/member/drop-plan'],
      },
    ],
  },
];

export const IAM_MENU_LIST: Menu[] = [
  {
    title: 'Access Management',
    menuItems: [
      { name: 'User Management', routerLink: '/access-management/account' },
      { name: 'Role Management', routerLink: '/access-management/roles' },
    ],
  },
  {
    title: 'Employer Portal',
    menuItems: [{ name: 'Role Management', routerLink: '/access-management/employer-portal-roles' }],
  },
];

export const REMITTANCE_POSTING_MENU_LIST: Menu[] = [
  {
    title: 'Remittance Posting',
    menuItems: [
      {
        name: 'Remittance Posting',
        routerLink: '/processing/remittance-posting',
        routerLinkExpand: ['/processing/remittance-posting'],
        fundType: FundType.BVFF,
      },
    ],
  },
];

export const PAYROLL_MENU_LIST: Menu[] = [
  {
    title: 'Retirees',
    menuItems: [
      {
        name: 'Next Payroll',
        routerLink: '/processing/next-payroll-list',
        routerLinkExpand: ['/processing/next-payroll/'],
        routerLinkExcept: ['payrollRegister=true']
      },
      {
        name: 'Payroll Register',
        routerLink: '/processing/payroll-register',
        routerLinkExpand: ['payrollRegister=true'],
      },
    ],
  },
  {
    title: 'Payroll Settings',
    icon: 'tune',
    style: 'padding-top: 16px; border-top: 1px solid #124462; margin-right: 15px;',
    menuItems: [
      { name: 'Deduction Payee', routerLink: '/processing/payment-deduction-payee' },
      { name: 'Deductions', routerLink: '/processing/payment-deductions' },
      { name: 'Calendar', routerLink: '/processing/payroll-calendar' },
    ],
  },
];

export const PAYMENT_MENU_LIST: Menu[] = [
  {
    title: 'Lump Sum Payments',
    menuItems: [
      {
        name: 'Off-Cycle Payments',
        routerLink: '/processing/off-cycle-payments',
        routerLinkExpand: ['prevScreen=1'],
      },
      {
        name: 'Payment History',
        routerLink: '/processing/lump-sum-payment-history',
        routerLinkExpand: ['prevScreen=2'],
      },
    ],
  },
];

export const PENDING_PAYMENT_MENU_LIST: Menu[] = [
  {
    title: 'Pending Payments',
    menuItems: [
      {
        name: 'Suspended Payments',
        routerLink: '/processing/suspended-payments',
        routerLinkExpand: ['/processing/suspended-payments'],
      },
      {
        name: 'Resolved Suspended Payments',
        routerLink: '/processing/resolved-suspended-payments',
        routerLinkExpand: ['/processing/resolved-suspended-payments'],
      },
      {
        name: 'Municipality Refund',
        routerLink: '/processing/municipality-refund',
        routerLinkExpand: ['prevScreen=1'],
        fundType: FundType.BVFF,
      },
    ],
  },
];

export const ONE_TIME_PAYMENT_MENU_LIST: Menu[] = [
  {
    title: 'One-Time Payments',
    menuItems: [
      {
        name: 'Pending Payments',
        routerLink: '/processing/otp-pending-payments',
        routerLinkExpand: ['/processing/otp-complete-payment'],
        routerLinkExcept: ['oneTimeRegister=true']
      },
      {
        name: 'One-Time Register',
        routerLink: '/processing/one-time-register',
        routerLinkExpand: ['oneTimeRegister=true'],
      },
    ],
  },
];

export const DEDUCTION_PAYEE_PAYMENTS_MENU_LIST: Menu[] = [
  {
    title: 'Deduction Payees',
    menuItems: [
      {
        name: 'Checks & Direct Deposits',
        routerLink: '/processing/dp-checks-and-direct-deposit',
        routerLinkExpand: ['/processing/dp-checks-and-direct-deposit-complete'],
        routerLinkExcept: ['dpRegister=true']
      },
      {
        name: 'Wire transfer & Internal Payments',
        routerLink: '/processing/wire-transfer-and-internal-payment',
        routerLinkExpand: ['/processing/wire-transfer-and-internal-payment-complete'],
        routerLinkExcept: ['dpRegister=true']
      },
      {
        name: 'Ded Payee Register',
        routerLink: '/processing/deduction-payee-register',
        routerLinkExpand: ['dpRegister=true']
      },
    ],
  },
];

export const YEARLY_MENU_LIST: Menu[] = [
  {
    title: 'Yearly',
    menuItems: [
      {
        name: '1099-R Pending Process',
        routerLink: '/processing/r-pending-process',
        routerLinkExpand: [],
        routerLinkRegex: ['/processing/r-pending-process(.+)[^(isHistory=true)]$'],
      },
      {
        name: '1099-R History',
        routerLink: '/processing/r-history',
        routerLinkExpand: ['/processing/r-history/'],
        routerLinkRegex: ['/processing/r-pending-process(.+)isHistory=true']
      }
    ],
  },
];

export const COLA_MENU_LIST: Menu[] = [
  {
    title: 'Cola',
    menuItems: [
      {
        name: 'Next Cola',
        routerLink: '/processing/next-cola-list',
        routerLinkExpand: ['/processing/next-cola/'],
        routerLinkExcept: ['colaRegister=true']
      },
      {
        name: 'Cola Register',
        routerLink: '/processing/cola-register',
        routerLinkExpand: ['/processing/cola-register/'],
        routerLinkExcept: ['colaRegister=true'],
      },
    ],
  },
];

export const TRANSACTION_REGISTER_MENU_LIST: Menu[] = [
  {
    title: 'Transaction',
    menuItems: [{ name: 'Transaction Register', routerLink: '/processing/transaction-register' }],
  },
];

export const REPORT_MENU_LIST: Menu[] = [
  {
    title: 'Reports',
    menuItems: [
      {
        name: 'Register Summary',
        routerLink: '/processing/report/register-summary',
        routerLinkExpand: ['processing/report/register-summary'],
      },
      {
        name: 'Register Detail',
        routerLink: '/processing/report/register-detail',
        routerLinkExpand: ['processing/report/register-detail'],
      },
      {
        name: 'Change Report',
        routerLink: '/processing/report/payroll-change-report',
        routerLinkExpand: ['processing/report/payroll-change-report'],
      },
      {
        name: 'Adjustment Report',
        routerLink: '/processing/report/adjustment-report',
        routerLinkExpand: ['processing/report/adjustment-report'],
      },
      {
        name: 'Direct Deposit Change',
        routerLink: '/processing/report/direct-deposit-change',
        routerLinkExpand: ['processing/report/direct-deposit-change'],
      },
      {
        name: ' Deduction Payment Report',
        routerLink: '/processing/report/deduction-payment-report',
        routerLinkExpand: ['processing/report/deduction-payment-report'],
      },
    ],
  },
  {
    title: 'Excel Report',
    menuItems: [
      {
        name: 'Vital Report',
        routerLink: '#',
        type: ItemMenuType.VitalReportDialog,
        fundType: FundType.ChicagoParks,
        fundKey: 'peabf',
      },
      {
        name: 'Life Status 360 Report',
        routerLink: '#',
        type: ItemMenuType.LifeStatus360ReportDialog,
        fundType: FundType.ChicagoParks,
        fundKey: 'peabf',
      },
      {
        name: 'SURS Reciprocal Report',
        routerLink: '#',
        type: ItemMenuType.SursReciprocalReportDialog,
        fundType: FundType.ChicagoParks,
        fundKey: 'peabf',
      },
    ],
  },
  {
    title: 'Generated Report',
    menuItems: [
      {
        name: 'Generated List',
        routerLink: '/processing/report/generated-list',
        routerLinkExpand: ['processing/report/generated-list', 'processing/report/generated-reports'],
      },
    ],
  }
];

export const ACCESS_MANAGEMENT_MENU_LIST: MenuGroup = {
  moduleKey: SUBMODULE_KEY.ACCESS_MANAGEMENT,
  name: 'access_management',
  menu: IAM_MENU_LIST,
  icon: 'vpn_key',
  permissionKey: PERMISSION_KEY.ACCESS_CONTROL,
};

export const EMPLOYER_OVERVIEW_MENU_LIST: Menu[] = [
  {
    title: '',
    menuItems: [
      { name: 'Overview', routerLink: '/employer/detail' },
      { name: 'Departments', routerLink: '/employer/department-management' },
      {
        name: 'Wage Processing',
        routerLink: '/employer/wage-processing',
      },
      {
        name: 'Document List',
        routerLink: '/employer/individual-document',
        routerLinkExpand: ['employer/individual-document'],
      },
    ],
  },
  {
    title: 'Employer Settings',
    icon: 'tune',
    style: 'padding-top: 16px; border-top: 1px solid #124462; margin-right: 15px;',
    menuItems: [
      {
        name: 'Parameters',
        routerLink: '/employer/parameters',
      },
      {
        name: 'Reporting Calendar',
        routerLink: '/employer/reporting-calendar',
      },
    ],
  },
];

export const TOLERANCE_MENU: Menu[] = [
  {
    title: 'Settings',
    menuItems: [
      {
        name: 'Tolerance Parameter',
        routerLink: '/employer/tolerance/parameters',
      },
      {
        name: 'Contribution Interest Rate',
        routerLink: '/employer/contribution-interest-rate',
      },
    ],
  },
];

export const BVFF_EMPLOYER_OVERVIEW_MENU_LIST: Menu[] = [
  {
    title: '',
    menuItems: [{ name: 'Profile', routerLink: '/employer/detail' }],
  },
  {
    title: MUNICIPALITY_PARTICIPANTS_MENU_TITLE,
    menuItems: [
      {
        name: 'All Members',
        routerLink: '/member',
        queryParams: {},
      },
      {
        name: 'Active Members',
        routerLink: '/member',
        queryParams: { status: 'Active' },
      },
      {
        name: 'Inactive Members',
        routerLink: '/member',
        queryParams: { status: 'Inactive' },
      },
    ],
  },
  {
    title: 'Annual Reporting',
    menuItems: [
      {
        name: 'Annual Certification',
        routerLink: '/employer/annual-certification-history',
        routerLinkExpand: ['/employer/annual-certification/'],
      },
      {
        name: 'Remittance',
        routerLink: '/employer/remittance-submission-history',
        routerLinkExpand: ['/employer/remittance-submission-history/'],
      },
      {
        name: 'Transactions',
        routerLink: '/employer/transactions',
        routerLinkExpand: ['/employer/transactions/'],
      },
    ],
  },
  {
    title: 'Documents',
    menuItems: [
      {
        name: 'Document List',
        routerLink: '/employer/individual-document',
        routerLinkExpand: ['employer/individual-document'],
      },
    ],
  },
];

export const BVFF_EMPLOYER_REPORT_MENU: Menu[] = [
  {
    title: 'Reports',
    id: 'reports',
    menuItems: [
      { name: 'Transactions', routerLink: '/employer/report-transactions' },
      { name: 'Annual Certification', routerLink: '/employer/report/annual-certification' },
    ],
  },
  {
    title: 'Relief Reports',
    id: 'relief-reports',
    menuItems: [{ name: 'Disbursement Summary', routerLink: '/employer/report-disbursement-summary' }],
  },
  {
    title: 'Pension Reports',
    id: 'pension-reports',
    menuItems: [],
  },
  {
    title: 'Letters',
    menuItems: [
      {
        name: 'Annual Fee Letter',
        routerLink: '/employer/annual-fee-letter',
      },
      {
        name: 'Late Fee Reminder',
        routerLink: '/employer/late-fee-reminder-letter',
      },
    ],
  },
];

export const BVFF_EMPLOYER_OVERVIEW_REPORT_PENSION_MENU: Menu[] = [
  {
    title: 'Pension Reports',
    menuItems: [
      {
        name: 'Service List',
        routerLink: '/employer/report-service-list',
      },
    ],
  },
  {
    title: 'Letters',
    menuItems: [
      {
        name: 'Annual Fee Letter',
        routerLink: '/employer/annual-fee-letter',
      },
      {
        name: 'Late Fee Reminder',
        routerLink: '/employer/late-fee-reminder-letter',
      },
    ],
  },
];

export const BVFF_EMPLOYER_SETTING_MENU: Menu[] = [
  {
    title: 'Settings',
    menuItems: [{ name: 'Fee Amounts', routerLink: '/employer/fee-amounts' }],
  },
];

export const PARTICIPANT_REPORT_MENU: Menu[] = [
  // added dynamically within the SidebarComponent
  {
    title: 'Generated Report',
    menuItems: [
      {
        name: 'Generated List',
        routerLink: '/member/report/generated',
        routerLinkExpand: ['/member/report/generated'],
      },
    ],
  },
];

export const EMPLOYER_DOCUMENT_LIST: Menu[] = [
  {
    title: 'All Documents',
    menuItems: [
      {
        name: 'All Document List',
        routerLink: '/employer/document-list',
        routerLinkExpand: ['/document-list'],
      },
      // FIXME apply to 96391 only
      // {
      //   name: 'Generated Document',
      //   routerLink: '/employer/generated-document',
      //   routerLinkExpand: ['/member/generated-document'],
      // },
    ],
  },
];

export const EXTERNAL_PAYMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.EXTERNAL_PAYMENT,
  name: 'DR',
  menu: EXTERNAL_PAYMENT_MENU_LIST,
  icon: 'paid',
  permissionKey: PERMISSION_KEY.EXTERNAL_PAYMENT,
};

export const RESOURCE_CENTER_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.RESOURCE_CENTER,
  name: 'RC',
  menu: RESOURCE_CENTER_MENU_LIST,
  icon: 'attach_file',
  permissionKey: PERMISSION_KEY.RESOURCE_CENTER,
};

export const APP_CONTENT_MANAGEMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.APP_CONTENT_MANAGEMENT,
  name: 'ACM',
  menu: CONTENT_MENU_LIST,
  icon: 'phonelink_setup',
  permissionKey: PERMISSION_KEY.APP_CONTENT,
};

export const THEME_MANAGEMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.PAS_MANAGEMENT,
  name: 'theme',
  menu: FUND_MENU_LIST,
  icon: 'handyman',
  permissionKey: PERMISSION_KEY.PAS_MANAGEMENT,
};
// OST_MENU_LIST
export const OST_INTEGRATION_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.OST_INTEGRATION,
  name: 'theme',
  menu: OST_MENU_LIST,
  icon: 'file_copy',
  permissionKey: PERMISSION_KEY.OST_INTEGRATION,
}

export const menuOrganization: Menu[] = [
  {
    title: 'Organization Management',
    menuItems: [
      {
        name: 'Fund Management',
        routerLink: '/organization/board-management',
      },
      // {
      //   name: 'Board Member',
      //   routerLink: '/organization/board-member',
      // },
      {
        name: 'Bank Account',
        routerLink: '/organization/banks-account',
      },
      {
        name: 'Bank Assignments',
        routerLink: '/organization/bank-assignments',
      },
      {
        name: '1099-R Payer Info',
        routerLink: '/organization/annual-1099-payer-info'
      },
      {
        name: '1099-R Email',
        routerLink: '/organization/1099-r-email'
      }
    ],
  },
];

export const DOCUMENT_CONFIGURATION_MENU_LIST: Menu[] = [
  {
    title: 'Documents',
    menuItems: [
      {
        name: 'Tags',
        routerLink: '/admin/documents/tags',
        routerLinkExpand: ['/admin/documents/tags/'],
      },
      // Todo: Don't release on 0.9d
      // {
      //   name: 'Parameters',
      //   routerLink: '/admin/documents/parameters',
      //   routerLinkExpand: ['/admin/documents/parameters/'],
      // },
      // {
      //   name: 'Templates',
      //   routerLink: '/admin/documents/templates',
      //   routerLinkExpand: ['/admin/documents/templates/'],
      // },
    ],
  },
];

export const ORGANIZATION_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.ORGANIZATION_MANAGEMENT,
  name: 'organization_management',
  menu: menuOrganization,
  icon: 'account_tree',
  permissionKey: PERMISSION_KEY.ORGANIZATION_MANAGEMENT,
};

export const MEMBER_MANAGEMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.PARTICIPANT_LIST,
  name: 'member_list',
  icon: 'list',
  permissionKey: PERMISSION_KEY.PARTICIPANTS,
  routerLink: '/member',
};

export const PENSION_ESTIMATOR_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.PENSION_ESTIMATOR,
  name: 'estimator',
  icon: pensionEstimatorIcon,
  isSVG: true,
  menu: PENSION_ESTIMATOR_LIST,
  permissionKey: PERMISSION_KEY.PENSION_ESTIMATOR,
};

export const MEMBER_DOCUMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.DOCUMENTS,
  name: 'document-list',
  icon: 'document_scanner',
  menu: MEMBER_DOCUMENT_LIST,
  permissionKey: PERMISSION_KEY.DOCUMENTS,
};

export const PENSION_DROP_PLAN_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.DROP_PLAN,
  name: 'drop_plan',
  icon: pensionDropPlanIcon,
  isSVG: true,
  menu: PENSION_DROP_PLAN_LIST,
  permissionKey: PERMISSION_KEY.DROP_PLAN,
};

export const MEMBER_BENEFIT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.ESTABLISH_BENEFIT,
  name: 'member_benefit',
  icon: 'calculate',
  permissionKey: PERMISSION_KEY.ESTABLISH_BENEFIT,
  routerLink: '/member/benefit',
};

export const NOTIFICATION_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.COMMUNICATIONS,
  name: 'comunication',
  icon: 'textsms',
  menu: NOTIFICATION_MENU_LIST,
  permissionKey: PERMISSION_KEY.COMMUNICATIONS,
};

// Hide Participant Report Menu Group on all fund types on Entity version
// export const PARTICIPANT_REPORT_MENU_GROUP: MenuGroup = {
//   moduleKey: SUBMODULE_KEY.PARTICIPANT_REPORT,
//   name: 'participant_report',
//   icon: 'stacked_bar_chart',
//   menu: PARTICIPANT_REPORT_MENU,
//   permissionKey: PERMISSION_KEY.PARTICIPANT_REPORT,
// };

export const BULK_UPDATE_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.BULK_CONTENT_UPDATES,
  name: 'bulk_update',
  icon: 'drive_folder_upload',
  menu: BULK_UPDATE_MENU_LIST,
  permissionKey: PERMISSION_KEY.BULK_CONTENT_UPDATES,
};

export const MEMBER_PROFILE_OVERVIEW_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.PARTICIPANT_LIST,
  name: 'demographics',
  icon: 'account_circle',
  menu: MEMBER_OVERVIEW_MENU_LIST,
  permissionKey: PERMISSION_KEY.PARTICIPANTS,
};

export const COMMUNICATIONS: Menu[] = [
  {
    title: 'Communication',
    menuItems: [
      {
        name: 'Opt-In Management',
        routerLink: '/member/opt-in',
        routerLinkExpand: ['member/opt-in'],
      },
    ],
  },
];

export const INDIVIDUAL_DOCUMENT_MENU: Menu[] = [
  {
    title: 'Documents',
    menuItems: [
      {
        name: 'Document List',
        routerLink: '/member/individual-document',
        routerLinkExpand: ['member/individual-document'],
      },
    ],
  },
];

export const MEMBER_COMMUNICATION_OVERVIEW_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.PARTICIPANT_LIST,
  name: 'opt-in',
  icon: 'message',
  menu: COMMUNICATIONS,
  permissionKey: PERMISSION_KEY.PARTICIPANTS,
};

export const MEMBER_INDIVIDUAL_DOCUMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.DOCUMENTS,
  name: 'individual_document',
  icon: 'document_scanner',
  menu: INDIVIDUAL_DOCUMENT_MENU,
  permissionKey: PERMISSION_KEY.DOCUMENTS,
};

export const MEMBER_RETIREMENT_BENEFITS: Menu[] = [
  {
    title: 'Benefit Processing',
    menuItems: [
      {
        name: 'Retirement Benefit',
        routerLink: `/member/benefit-overview/${CalculationType.RetirementBenefit}/`,
        routerLinkExpand: [`/member/benefit-overview/${CalculationType.RetirementBenefit}/`],
      },
      {
        name: 'Survivor',
        routerLink: `/member/benefit-overview/${CalculationType.Survivor}/`,
        routerLinkExpand: [
          `/member/benefit-overview/${CalculationType.Survivor}/`,
          `/member/benefit-overview/${CalculationType.JointSurvivor}/`,
          `/member/benefit-overview/${CalculationType.LODDDeath}/`,
          `/member/benefit-overview/${CalculationType.LODDSurvivor}/`,
          `/member/benefit-overview/${CalculationType.ChildSurvivor}/`,
        ],
        fundType: [FundType.BVFF, FundType.ChicagoParks],
      },
      {
        id: 'QDRO',
        name: CalculationType[CalculationType.QDRO],
        routerLink: `/member/benefit-overview/${CalculationType.QDRO}/`,
        routerLinkExpand: [`/member/benefit-overview/${CalculationType.QDRO}/`],
        fundType: [FundType.BVFF, FundType.ChicagoParks],
      },
      {
        name: 'Disability',
        routerLink: `/member/disability-overview/${CalculationType.Disability}/`,
        routerLinkExpand: [
          `/member/disability-overview/${CalculationType.Disability}/`,
          `/member/disability-overview/${CalculationType.DisabilityShortTerm}/`,
          `/member/disability-overview/${CalculationType.DisabilityLongTerm}/`,
        ],
        fundType: FundType.BVFF,
      },
      {
        name: 'Accident',
        routerLink: '/member/accident/',
        routerLinkExpand: ['/member/accident/'],
        fundType: FundType.BVFF,
      },
    ],
  },
  {
    title: 'Purchase Services',
    menuItems: [
      {
        name: 'Buyback/Make-up',
        routerLink: `/member/buyback-makeup-overview/`,
        routerLinkExpand: [`/member/buyback-makeup-overview/`],
      },
    ],
    fundType: FundType.BVFF,
  },
  {
    title: 'Returns Processing',
    menuItems: [
      {
        name: 'Refunds',
        routerLink: `/member/refunds-overview/`,
        routerLinkExpand: [`/member/refunds-overview/`],
      },
    ],
    fundType: FundType.BVFF,
  },
];

export const MEMBER_RETIREMENT_BENEFIT_OVERVIEW_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.PARTICIPANT_LIST,
  name: 'retirement-benefit',
  icon: 'calculate',
  menu: MEMBER_RETIREMENT_BENEFITS,
  permissionKey: PERMISSION_KEY.PARTICIPANTS,
};

export const REMITTANCE_POSTING_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.PARTICIPANT_CONTRIBUTIONS,
  name: 'remittance-posting',
  icon: 'savings',
  menu: REMITTANCE_POSTING_MENU_LIST,
};

export const PAYROLL_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.RECURRING_PAYMENTS,
  name: 'payroll',
  icon: 'payments',
  menu: PAYROLL_MENU_LIST,
};

export const PENDING_PAYMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.PENDING_PAYMENTS,
  name: 'pending-payments',
  icon: 'account_balance_wallet',
  menu: PENDING_PAYMENT_MENU_LIST,
};

export const ONE_TIME_PAYMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.ONE_TIME_PAYMENTS,
  name: 'one-time-payments',
  icon: priceChange,
  isSVG: true,
  menu: ONE_TIME_PAYMENT_MENU_LIST,
};

export const DEDUCTION_PAYEE_PAYMENTS_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.DEDUCTION_PAYEE_PAYMENTS,
  name: 'deduction-payees',
  icon: 'home_repair_service',
  menu: DEDUCTION_PAYEE_PAYMENTS_MENU_LIST,
};

export const PAYMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.LUMP_SUM_PAYMENTS,
  name: 'payment',
  icon: 'paid',
  menu: PAYMENT_MENU_LIST,
};

export const TRANSACTION_REGISTER_MENU_GROUP = {
  moduleKey: SUBMODULE_KEY.TRANSACTION_REGISTER,
  name: 'transaction_register',
  icon: 'content_paste_go',
  menu: TRANSACTION_REGISTER_MENU_LIST,
};

//NEED TO UPDATE WITH SUBMODULE KEY
export const YEARLY_MENU_GROUP = {
  // moduleKey: SUBMODULE_KEY.TRANSACTION_REGISTER,
  // name: 'transaction_register',
  moduleKey: SUBMODULE_KEY.YEARLY_PROCESSING,
  name: 'yearly_processing',
  icon: 'edit_calendar',
  menu: YEARLY_MENU_LIST,
};

export const COLA_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.COLA_PROCESSING,
  name: 'cola_processing',
  icon: 'cola',
  menu: COLA_MENU_LIST,
};

export const REPORT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.REPORTS,
  name: 'report',
  icon: 'equalizer',
  menu: REPORT_MENU_LIST,
};

export const EMPLOYERS_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.EMPLOYER_LIST,
  name: '',
  icon: 'apartment',
  routerLink: '/employer/employer-management',
  permissionKey: PERMISSION_KEY.EMPLOYERS,
};

export const BVFF_EMPLOYERS_REPORT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.EMPLOYER_LIST,
  name: 'employer_report',
  icon: 'stacked_bar_chart',
  permissionKey: PERMISSION_KEY.EMPLOYER_LIST,
  menu: BVFF_EMPLOYER_REPORT_MENU,
};

export const BVFF_EMPLOYERS_SETTING_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.EMPLOYER_LIST,
  name: '',
  icon: 'tune',
  permissionKey: PERMISSION_KEY.EMPLOYER_LIST,
  menu: BVFF_EMPLOYER_SETTING_MENU,
};

export const TOLERANCE_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.EMPLOYER_LIST,
  name: '',
  icon: 'tune',
  permissionKey: PERMISSION_KEY.EMPLOYER_LIST,
  menu: TOLERANCE_MENU,
};

export const BVFF_EMPLOYER_OVERVIEW_REPORT_PENSION_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.EMPLOYER_LIST,
  name: '',
  icon: 'tune',
  permissionKey: PERMISSION_KEY.EMPLOYER_LIST,
  menu: BVFF_EMPLOYER_OVERVIEW_REPORT_PENSION_MENU,
};

export const DOCUMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.DOCUMENT_CONFIGURATION,
  name: '',
  icon: 'document_scanner',
  permissionKey: PERMISSION_KEY.DOCUMENT_CONFIGURATION,
  menu: DOCUMENT_CONFIGURATION_MENU_LIST,
};

export const MENU_TYPE = {
  PROFILE_NAVIGATION: 'profile-navigation',
};

export const EMPLOYER_DOCUMENT_MENU_GROUP: MenuGroup = {
  moduleKey: SUBMODULE_KEY.EMPLOYER_DOCUMENT,
  name: 'document-list',
  icon: 'document_scanner',
  menu: EMPLOYER_DOCUMENT_LIST,
  permissionKey: PERMISSION_KEY.EMPLOYER_DOCUMENT,
};

// Hide Participant Report Menu Group on all fund types on Entity version
export const PARTICIPANTS_MENU_GROUPS = [
  MEMBER_MANAGEMENT_MENU_GROUP,
  MEMBER_BENEFIT_MENU_GROUP,
  PENSION_ESTIMATOR_MENU_GROUP,
  PENSION_DROP_PLAN_MENU_GROUP,
  NOTIFICATION_MENU_GROUP,
  BULK_UPDATE_MENU_GROUP,
  // PARTICIPANT_REPORT_MENU_GROUP,
  MEMBER_DOCUMENT_MENU_GROUP,
];

export const PARTICIPANT_OVERVIEW_MENU_GROUPS = [
  MEMBER_PROFILE_OVERVIEW_MENU_GROUP,
  MEMBER_COMMUNICATION_OVERVIEW_MENU_GROUP,
  MEMBER_RETIREMENT_BENEFIT_OVERVIEW_MENU_GROUP,
  MEMBER_INDIVIDUAL_DOCUMENT_MENU_GROUP,
];

export const INDIVIDUAL_EMPLOYER_MENU_GROUPS = [EMPLOYERS_MENU_GROUP, BVFF_EMPLOYER_OVERVIEW_REPORT_PENSION_MENU_GROUP];

export const ADMIN_MENU_GROUPS = [
  ACCESS_MANAGEMENT_MENU_LIST,
  EXTERNAL_PAYMENT_MENU_GROUP,
  RESOURCE_CENTER_MENU_GROUP,
  ORGANIZATION_MENU_GROUP,
  DOCUMENT_MENU_GROUP,
  THEME_MANAGEMENT_MENU_GROUP,
  OST_INTEGRATION_MENU_GROUP
];
export const PROCESSING_MENU_GROUPS = [
  REMITTANCE_POSTING_MENU_GROUP,
  PENDING_PAYMENT_MENU_GROUP,
  PAYROLL_MENU_GROUP,
  PAYMENT_MENU_GROUP,
  TRANSACTION_REGISTER_MENU_GROUP,
  YEARLY_MENU_GROUP,
  REPORT_MENU_GROUP,
  ONE_TIME_PAYMENT_MENU_GROUP,
  DEDUCTION_PAYEE_PAYMENTS_MENU_GROUP,
  COLA_MENU_GROUP
];

export const APP_CONTENT_MENU_GROUPS = [APP_CONTENT_MANAGEMENT_MENU_GROUP];

export const EMPLOYERS_MENU_GROUPS = [EMPLOYERS_MENU_GROUP, TOLERANCE_MENU_GROUP, EMPLOYER_DOCUMENT_MENU_GROUP];

export const DEFAULT_TAB_MENU_GROUPS: Record<DisplayedTabName, MenuGroup[]> = {
  employers: EMPLOYERS_MENU_GROUPS,
  participants: PARTICIPANTS_MENU_GROUPS,
  admin: ADMIN_MENU_GROUPS,
  processing: PROCESSING_MENU_GROUPS,
  individualParticipant: PARTICIPANT_OVERVIEW_MENU_GROUPS,
  searchedParticipant: PARTICIPANT_OVERVIEW_MENU_GROUPS,
  app: APP_CONTENT_MENU_GROUPS,
  individualEmployer: INDIVIDUAL_EMPLOYER_MENU_GROUPS,
};
